
<template>
  <div class="content">
    <!-- <div class="header">
            <div>消息内容</div>
            <div>日期</div>
        </div>
        <div class="tab">
            
    </div>-->
    <el-table
      ref="multipleTable"
      :data="msglist"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>

      <el-table-column label="消息内容">
        <template slot-scope="scope">
          <div v-html="scope.row.mes"></div>
        </template>
      </el-table-column>
      <el-table-column prop="isread" width="80" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.isread">已读</span>
          <span v-else>未读</span>
        </template>
      </el-table-column>
      <el-table-column prop="createtime" width="150" label="日期"></el-table-column>
      <el-table-column width="150" :label="'操作'">
        <template slot-scope="scope">
          <el-button
            type="primary"
            v-if="scope.row.isread==false"
            plain
            size="mini"
            @click="certiisRead(scope.row)"
          >未读</el-button>
          <el-button type="info" v-else plain size="mini">已读</el-button>
          <el-button type="danger" plain size="mini" @click="delet(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="100"
        layout="total,sizes, prev, pager, next"
        :total="total1"
        v-if="total1>0"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import * as PersonCenter from '@/api/personcenter/index';
export default {
  data() {
    return {
      multipleSelection: [], //多选框数组
      listQuery: {
        page: 1,
        limit: 10,
        userId: this.$store.state.User.ids,
      },
      msglist: [],
      total1: 0,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 删除
    delet(row) {
      let data = { id: row.id };
      PersonCenter.DeleteMes(data).then((res) => {
        this.$notify({
          title: '成功',
          message: '成功',
          type: 'success',
          duration: 2000,
        });
        this.getList();
      });
    },
    // 提交已读
    certiisRead(row) {
      let data = {
        id: row.id,
      };

      PersonCenter.GetMesPassSt(data).then((res) => {
        this.$notify({
          title: '成功',
          message: '成功',
          type: 'success',
          duration: 2000,
        });
        this.getList();
      });
    },
    getList() {
      PersonCenter.GetMesListmsg(this.listQuery).then((res) => {
        this.msglist = res.data;
        this.total1 = res.count;
      });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style scoped>
.content {
  /* width: 900px; */
  width: 100%;
  /* height: 1000px; */
  padding-bottom: 20px;
}
.header {
  height: 40px;
  display: flex;
  line-height: 40px;
  padding-left: 100px;
  font-size: 16px;
  background-color: #fff;
  box-shadow: 2px 2px 5px rgba(215, 215, 215, 0.968627450980392);
}
.header > div:nth-child(1) {
  flex: 3;
}
.header > div:nth-child(2) {
  flex: 2;
  margin-left: 200px;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
</style>